<div class="extra-narrow-content" *ngIf="accounts">
  <mat-card>
    <mat-card-content>
      <h1>Accounts</h1>
      <div class="standard-list">
        <ng-container *ngFor="let account of accounts">
          <div
            *ngFor="let org of account.orgs"
            class="list-item list-item-triple"
          >
            <div class="left-icon" (click)="selectUser(org.userId)">
              <mat-icon
                matListItemIcon
                *ngIf="loggedIn && org.userId === loggedIn.user._id"
              >
                check
              </mat-icon>
              <mat-icon
                matListItemIcon
                *ngIf="org.userId !== loggedIn?.user?._id"
              >
                none
              </mat-icon>
            </div>
            <div class="list-item-title" (click)="selectUser(org.userId)">
              <div>{{ org.name }}</div>
              <div class="list-item-sub-title">{{ account.email }}</div>
            </div>
            <div>
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="logOut(account.accountId)">
                  <span>Log out of {{ account.email }}</span>
                </button>
              </mat-menu>
            </div>
          </div>

          <!-- If the user has no organization -->
          <div
            *ngIf="account.orgs.length === 0"
            class="list-item list-item-triple"
          >
            <div class="left-icon" (click)="selectAccount(account.accountId)">
              <mat-icon
                matListItemIcon
                *ngIf="loggedIn && account.accountId === loggedIn.accountId"
              >
                check
              </mat-icon>
              <mat-icon
                matListItemIcon
                *ngIf="loggedIn && account.accountId !== loggedIn.accountId"
              >
                none
              </mat-icon>
            </div>

            <div
              class="list-item-title"
              (click)="selectAccount(account.accountId)"
            >
              <div>No organization</div>
              <div class="list-item-sub-title">{{ account.email }}</div>
            </div>

            <div>
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="logOut(account.accountId)">
                  <span>Log out of {{ account.email }}</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </ng-container>
      </div>

      <h2>Add account</h2>
      <button
        mat-raised-button
        color="primary"
        (click)="logInToAnotherAccount()"
      >
        Log into another account
      </button>

      <h2>Log out</h2>
      <button mat-raised-button color="warn" (click)="logOut()">
        Log out all users
      </button>
    </mat-card-content>
  </mat-card>
</div>
